import { render } from "./Select2Locale.vue?vue&type=template&id=928150e0&scoped=true"
import script from "./Select2Locale.vue?vue&type=script&lang=js"
export * from "./Select2Locale.vue?vue&type=script&lang=js"

import "./Select2Locale.vue?vue&type=style&index=0&id=928150e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-928150e0"]])

export default __exports__